import type { ClimbRouteLogResponse, Discipline, Grade, SendType } from "@/types/api";
import client from "./client";

export async function logRoute(
  sessionId: number,
  data: {
    grade: Grade;
    is_tall_wall: boolean;
    send_type: SendType;
    discipline?: Discipline;
    route_name?: string;
    notes?: string;
  }
): Promise<ClimbRouteLogResponse> {
  const res = await client.post<ClimbRouteLogResponse>(
    `/sessions/${sessionId}/routes`,
    data
  );
  return res.data;
}

export async function updateRoute(
  sessionId: number,
  routeId: number,
  data: {
    grade?: Grade;
    send_type?: SendType;
    discipline?: Discipline;
    route_name?: string | null;
    notes?: string | null;
  }
): Promise<import("@/types/api").ClimbRouteOut> {
  const res = await client.patch<import("@/types/api").ClimbRouteOut>(
    `/sessions/${sessionId}/routes/${routeId}`,
    data
  );
  return res.data;
}

export async function deleteRoute(sessionId: number, routeId: number): Promise<void> {
  await client.delete(`/sessions/${sessionId}/routes/${routeId}`);
}

export async function deleteRoutePhoto(
  sessionId: number,
  routeId: number
): Promise<import("@/types/api").ClimbRouteOut> {
  const res = await client.delete<import("@/types/api").ClimbRouteOut>(
    `/sessions/${sessionId}/routes/${routeId}/photo`
  );
  return res.data;
}

export async function deleteRouteVideo(
  sessionId: number,
  routeId: number
): Promise<import("@/types/api").ClimbRouteOut> {
  const res = await client.delete<import("@/types/api").ClimbRouteOut>(
    `/sessions/${sessionId}/routes/${routeId}/video`
  );
  return res.data;
}

export async function uploadRoutePhoto(
  sessionId: number,
  routeId: number,
  blob: Blob
): Promise<void> {
  const form = new FormData();
  form.append("file", blob, "photo.jpg");
  await client.post(`/sessions/${sessionId}/routes/${routeId}/photo`, form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export async function uploadRouteVideo(
  sessionId: number,
  routeId: number,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<void> {
  const form = new FormData();
  form.append("file", file);
  await client.post(`/sessions/${sessionId}/routes/${routeId}/video`, form, {
    headers: { "Content-Type": "multipart/form-data" },
    onUploadProgress: onProgress
      ? (e) => { if (e.total) onProgress(Math.round((e.loaded / e.total) * 100)); }
      : undefined,
  });
}

export async function fetchRouteVideoUrl(sessionId: number, routeId: number): Promise<string> {
  const res = await client.get<{ url: string }>(`/sessions/${sessionId}/routes/${routeId}/video`);
  return res.data.url;
}

export { getChallengeStatus, getChallengeHistory } from "./challenge";
